module.exports = __webpack_public_path__ + "img/setting-5.54253478.svg";